import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  type EntityListOfOrbitLOnboardingListItemDto,
  getMerchantsOrbitLOnboardingList,
  type SortDirection,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const ORBIT_L_ONBOARDING_LIST_QUERY_KEY = "ORBIT_L_ONBOARDING_LIST";

export type OrbitLOnboardingListFilter = {
  companyName?: string;
  companyNumber?: string;
  hunterName?: string;
  comgateMID?: string;
  comgateStatuses?: string[];
  financingModels?: string[];
  orbitLPhases?: string[];
  hasOpenTerminalCountRequest?: boolean;
  activatedFrom?: string;
  activatedTo?: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  sortDirection?: SortDirection;
};

export const orbitLOnboardingListKeys = {
  all: [ORBIT_L_ONBOARDING_LIST_QUERY_KEY],
  list: (filter: OrbitLOnboardingListFilter) => [
    ...orbitLOnboardingListKeys.all,
    filter,
  ],
};

type QueryOptions = {
  enabled?: boolean;
  filter?: OrbitLOnboardingListFilter;
};

export const useOrbitLOnboardingListQuery = ({
  enabled = true,
  filter = {},
}: QueryOptions = {}) =>
  useQuery<EntityListOfOrbitLOnboardingListItemDto>({
    queryKey: orbitLOnboardingListKeys.list(filter),
    queryFn: processResponseWithApiProblemDetails(() =>
      getMerchantsOrbitLOnboardingList(
        filter.companyName,
        filter.companyNumber,
        filter.hunterName,
        filter.comgateMID,
        filter.comgateStatuses,
        filter.financingModels,
        filter.orbitLPhases,
        filter.hasOpenTerminalCountRequest,
        filter.activatedFrom,
        filter.activatedTo,
        filter.offset,
        filter.limit,
        filter.sortBy,
        filter.sortDirection,
      ),
    ),
    enabled,
    placeholderData: keepPreviousData,
    staleTime: 2 * MS_TIME.minute,
  });
